import { render, staticRenderFns } from "./share-sosmed-product.vue?vue&type=template&id=f80e7a8a"
import script from "./share-sosmed-product.vue?vue&type=script&lang=js"
export * from "./share-sosmed-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports